export const APPLICATION_LOGIN_PERMISSION = 'auth.getTokenByAccountId';
export const APPLICATION_LOGIN_HOSTNAME = 'app.kontrolx.com.tr';

const configuredSupportBaseUrl = process.env.REACT_APP_SUPPORT_APP_BASE_URL?.trim();

export const SUPPORT_APP_BASE_URL = (
  configuredSupportBaseUrl || 'https://support.kontrolx.com.tr'
).replace(/\/+$/, '');

export const isApplicationLoginHost = (hostname: string = window.location.hostname) =>
  hostname === APPLICATION_LOGIN_HOSTNAME;

